import { createApi } from "@reduxjs/toolkit/query/react";
import createBaseQuery from "./createBaseQuery";
export function createClustersApi(baseUrl) {
    return createApi({
        reducerPath: `clustersAPI_${baseUrl}`,
        baseQuery: createBaseQuery(baseUrl),
        endpoints: (build)=>({
                createCluster: build.mutation({
                    query: (body)=>({
                            url: "api/cluster/init",
                            method: "POST",
                            body
                        })
                }),
                joinCluster: build.mutation({
                    query: (body)=>({
                            url: "api/cluster/join",
                            method: "POST",
                            body
                        })
                }),
                generateJoinToken: build.mutation({
                    query: ()=>({
                            url: "api/cluster/control-plane/join-token",
                            method: "POST"
                        })
                })
            })
    });
}
